import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import List from '../../list/list'
import ListExpandable from '../../list/list-expandable'
import Text from '../../form/form-text'
import Select from '../../form/form-select'

import Pub from './pub'

class ModuleTeamRankingGroupWidget extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.template = this.template.bind(this)

        this.types = ["Web", "Tablette", "Mobile"].map( t => ({id: t, value: t}) );
        this.pubPositions = [];
        ["Frame", "Top", "Bottom"].forEach( position => [1,2,3].forEach(num => this.pubPositions.push(position + num))  );
        this.pubPositions = this.pubPositions.map( t => ({id: t, value: t}) );
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    template(device) {
        let { disabled } = this.state;
        return <div className="module-pub-devices">
            <Select disabled={disabled} value={device.type} options={this.types} />
            <Text disabled={disabled} value={device.width} />
            <Text disabled={disabled} value={device.height} />
        </div>
    }

    render() {
        let { devices, group, onChange, pubPosition } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-pub">
            <Text disabled={disabled} value={group} lablel="app.group"/>

            <Pub />
        </div>;
    }
}

ModuleTeamRankingGroupWidget.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    pub: PropTypes.shape({
        pubPosition: PropTypes.string, // souhld be .isRequired,.isRequired,
        devices: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.string.isRequired,
                width: PropTypes.string.isRequired,
                height: PropTypes.string.isRequired
            }))
    })
}

export default ModuleTeamRankingGroupWidget;

